<template>
  <!-- cust-shadow  -->
  <div>
    <div class="rounded-2xl  flex  mt-2">
      <!-- shadow-md shadow-order -->
      <div
        class="py-10 px-10 w-1/3"
        v-for="(item, index) in steps"
        :key="'item -' + index"
      >
        <div class="flex">
          <div
            class="rounded-full squarewidth flex justify-center bg-f4f5f6 items-center "
          >
            <feather-icon
              :icon="item.icon"
              class="cursor-pointer text-primary"
            ></feather-icon>
          </div>
          <div class="pt-1 pl-6">
            <p class="mb-1 font-bold theme-color-tx text-xl">
              {{ item.count }}
            </p>
            <small class="text-muted font-normal text-sm">
              {{ item.description }}
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      steps: [
        {
          icon: "ClockIcon",
          count: "20",
          description: "Pending Requests"
        },
        {
          icon: "ThumbsUpIcon",
          count: "25",
          description: "Accepted Requests"
        },
        {
          icon: "ThumbsDownIcon",
          count: "25",
          description: "Disapproved Request"
        }
      ]
    };
  }
};
</script>
